/**
 * PDP star rating — fill the custom fallback stars from the Yotpo bottomline API.
 *
 * The native Yotpo widget is hidden in section-main-product.css
 * (`.pdp-rating .yotpo-widget-instance { display: none }`) so the design's own
 * 16px stars are used instead. But that fallback was hardcoded to "0.0 / 0" and
 * nothing populated it — so every product showed an empty rating even when it
 * had reviews. This mirrors the collection/search approach (plp-app.js /
 * algolia-native.js): fetch the bottomline once and render the real score,
 * stars and count. Products with no reviews keep the row visible showing
 * 0.0 with five empty stars.
 */
(function () {
  var YOTPO_KEY = 'bzwqO2raPh4O7OoNJaS3vueIBxaZuBnxORwqBmmi';
  var STAR_PATH = 'M8 0l2.47 5.01L16 5.81l-4 3.9.94 5.49L8 12.49l-4.94 2.71L4 9.71 0 5.81l5.53-.8L8 0z';
  var seq = 0;

  function starSvg(type) {
    if (type === 'half') {
      var id = 'pdp-star-half-' + (++seq);
      return '<svg class="pdp-rating__star" width="16" height="16" viewBox="0 0 16 16">'
        + '<defs><linearGradient id="' + id + '"><stop offset="50%" stop-color="#F04F36"/>'
        + '<stop offset="50%" stop-color="#EEEEEE"/></linearGradient></defs>'
        + '<path d="' + STAR_PATH + '" fill="url(#' + id + ')"/></svg>';
    }
    var fill = type === 'full' ? '#F04F36' : '#EEEEEE';
    return '<svg class="pdp-rating__star" width="16" height="16" viewBox="0 0 16 16">'
      + '<path d="' + STAR_PATH + '" fill="' + fill + '"/></svg>';
  }

  function renderStars(avg) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (avg >= i) html += starSvg('full');
      else if (avg >= i - 0.5) html += starSvg('half');
      else html += starSvg('empty');
    }
    return html;
  }

  function init() {
    var row = document.querySelector('.pdp-rating-row');
    var widget = document.querySelector('.pdp-rating .yotpo-widget-instance');
    var fallback = document.querySelector('.pdp-rating__fallback');
    if (!row || !widget || !fallback) return;

    fallback.addEventListener('click', function () {
      // #product-reviews is rendered async by yotpo-custom.js; fall back to
      // the section host element if the widget hasn't finished rendering yet.
      var target = document.getElementById('product-reviews')
        || document.querySelector('yotpo-reviews-section');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var pid = widget.getAttribute('data-yotpo-product-id');
    if (!pid) return;

    window.fetch('https://api-cdn.yotpo.com/v1/widget/' + YOTPO_KEY + '/products/' + pid + '/reviews.json?per_page=1')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var bl = data && data.response && data.response.bottomline;
        var count = bl ? (bl.total_review || 0) : 0;
        var avg = count ? (bl.average_score || 0) : 0;
        var score = fallback.querySelector('.pdp-rating__score');
        var stars = fallback.querySelector('.pdp-rating__stars');
        var cnt = fallback.querySelector('.pdp-rating__count');
        if (score) score.textContent = avg.toFixed(1);
        if (stars) stars.innerHTML = renderStars(avg);
        if (cnt) cnt.textContent = '(' + count + ')';
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
